import { useLanguage } from '../../../core/i18n/hooks/use-language';
import { BASE_BACKEND_QUERY_KEY, BASE_BACKEND_URL } from '../../backend/constants';
import { QueryOptions } from '../../backend/hooks/use-authenticated-query';
import { useAnonymousQuery } from '../../backend/hooks/use-anonymous-query';
import {
  GetAnonymousCreateNewUserForExistingCustomerResponse,
  GetAnonymousCreateNewUserForNewCustomerResponse,
} from '../../backend/openapi/api-types';
import { AnonymousFormType } from '../types';

type ResponseTypeMap = {
  createNewUserForExistingCustomer: GetAnonymousCreateNewUserForExistingCustomerResponse;
  createNewUserForNewCustomer: GetAnonymousCreateNewUserForNewCustomerResponse;
};

const urlMap = {
  createNewUserForExistingCustomer: `${BASE_BACKEND_URL}/request-forms/anonymous-create-new-user-for-existing-customer`,
  createNewUserForNewCustomer: `${BASE_BACKEND_URL}/request-forms/anonymous-create-new-user-for-new-customer`,
};

export const useAnonymousFormQuery = <T extends AnonymousFormType>(formType: T) => {
  const language = useLanguage();
  const queryOptions: QueryOptions<ResponseTypeMap[T]> = {
    options: {
      queryKey: [BASE_BACKEND_QUERY_KEY, language, 'anonymous', formType],
    },
    url: urlMap[formType],
  };
  return useAnonymousQuery<ResponseTypeMap[T]>(queryOptions);
};
